/* ============
 * Login Index Page
 * ============
 *
 * Page where the user can login
 */

import authService from "./../../../services/auth";
import configurationService from "./../../../services/configuration";
import mixin from "../../../mixins/mixin";

export default {
  data() {
    return {
      user: {
        email: null,
        password: null,
        remember_me: 1,
        twofa_request_id: "",
        twofa_code1: "",
        twofa_code2: "",
        twofa_code3: "",
        twofa_code4: "",
        twofa_code5: "",
        twofa_code6: "",
      },
      detectScreenSize: window.matchMedia("(max-width: 1000px)"),
      showModalButton: false,
      smallLoading: false,
      topBarInfoStyle: {
        width: "100%",
        height: "30px",
        color: "#FFFFFF",
        backgroundColor: "#D7092E",
        paddingTop: "10px",
        paddingBottom: "10px",
      },
      topBarInfoText: "",
      topBarInfoEnabled: false,
      twoFaByEmailModeEnabled: true,
      hiddenEmail: "********",
      hiddenPhone: "********",
    };
  },

  components: {
    VLoading: require("components/loading/loading.vue"),
    VInputPassword: require("components/password-input/VueInputPassword.vue"),
  },

  watch: {
    "user.twofa_code1"() {
      document.getElementById("twofa_code2").focus();
    },
    "user.twofa_code2"() {
      document.getElementById("twofa_code3").focus();
    },
    "user.twofa_code3"() {
      document.getElementById("twofa_code4").focus();
    },
    "user.twofa_code4"() {
      document.getElementById("twofa_code5").focus();
    },
    "user.twofa_code5"() {
      document.getElementById("twofa_code6").focus();
    },
  },

  mounted() {
    const vm = this;

    const hash = window.location.hash;
    const queryString = hash.includes("?") ? hash.split("?")[1] : "";
    const params = new URLSearchParams(queryString);
    const token = params.get("token");

    if (token !== null) {
      vm.loginAsSupport(token);
    } else {
      if (localStorage.getItem("isConfirmed") === 1) {
        toastr.success(vm.$t("register.after_confirm_alert"));
        localStorage.removeItem("isConfirmed");
      }

      vm.fetch_configuration();

      vm.showModal(vm.detectScreenSize);
      vm.detectScreenSize.addListener(vm.showModal);
    }
  },

  mixins: [mixin],

  methods: {
    showModal(ev) {
      if (ev.matches) {
        $("#modalBtn").click();
      }
    },

    async fetch_configuration() {
      const vm = this;
      const response = await configurationService.get(vm);
      vm.topBarInfoText = response.conf.top_bar_info_text;
      vm.topBarInfoEnabled = response.conf.top_bar_info_enabled;
      vm.topBarInfoStyle.backgroundColor = response.conf.top_bar_info_color;
    },

    async loginAsSupport(token) {
      this.smallLoading = true;

      const data = {
        token,
      };
      await authService.loginAsSupport(data, this);
    },

    async login(user) {
      this.smallLoading = true;

      this.twoFaByEmailModeEnabled = false;
      // use 2FA only on registration for now
      // await authService.loginWith2fa(user, this);
      await authService.login(user, this);

      if (this.user.twofa_request_id !== "") {
        this.openregister2faModal();
      }
    },

    async resend2faCode() {
      this.smallLoading = true;
      this.user.twofa_code = "";
      this.user.twofa_code1 = "";
      this.user.twofa_code2 = "";
      this.user.twofa_code3 = "";
      this.user.twofa_code4 = "";
      this.user.twofa_code5 = "";
      this.user.twofa_code6 = "";

      if (this.twoFaByEmailModeEnabled)
        await authService.resend2faCodeByEmailForLogin(this.user, this);
      else await authService.resend2faCodeBySmsForLogin(this.user, this);
    },

    async confirm2faCode() {
      this.smallLoading = true;

      if (this.user.twofa_request_id !== null) {
        this.user.twofa_code =
          this.user.twofa_code1 +
          this.user.twofa_code2 +
          this.user.twofa_code3 +
          this.user.twofa_code4 +
          this.user.twofa_code5 +
          this.user.twofa_code6;

        if (this.twoFaByEmailModeEnabled)
          await authService.confirm2faCodeByEmailForLogin(this.user, this);
        else await authService.confirm2faCodeBySmsForLogin(this.user, this);
      }
    },

    openregister2faModal() {
      this.openModal("#register-2fa-modal");
      this.user.twofa_code = "";
    },

    closeregister2faModal() {
      this.closeModal("#register-2fa-modal");
      this.user.twofa_code = "";
    },

    modify2faMode() {
      this.user.twofa_code = "";
      this.user.twofa_code1 = "";
      this.user.twofa_code2 = "";
      this.user.twofa_code3 = "";
      this.user.twofa_code4 = "";
      this.user.twofa_code5 = "";
      this.user.twofa_code6 = "";
      this.twoFaByEmailModeEnabled = !this.twoFaByEmailModeEnabled;

      this.smallLoading = true;
      if (this.twoFaByEmailModeEnabled)
        authService.resend2faCodeByEmailForLogin(this.user, this);
      else authService.resend2faCodeBySmsForLogin(this.user, this);
    },

    handleBackspaceKey(twofaInputId) {
      document.getElementById("twofa_code" + (twofaInputId - 1)).focus();
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/login/index/index.js